import axios from "axios";
import { UserOptionsParameters } from "app/api/types";
import config from "app/api/axiosConfig";

export default (token: string, options: UserOptionsParameters ) =>
	axios.post(`${process.env.REACT_APP_CHAT_HOST}/Api/UserOptions`, options, config(token))
